import { Modal, ModalHeader } from '@fountain/fountain-ui-components';
import { makeStyles } from '@material-ui/core';
import React, { VFC } from 'react';
import { useDispatch } from 'react-redux';

import { updateApplicantTableStatuses } from 'containers/ApplicantTableV2/actions';
import { fetchApplicantData } from 'hooks/useApplicantDetail';

import { ScorecardForm } from './ScorecardForm';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 20,
    fontWeight: theme.typography.fontWeightBold as number,
  },
}));

export interface ScoreApplicantModalProps {
  applicantId: string;
  scorecardTemplateId: string;
  scorecardName: string;
  handleClose: () => void;
}

export const ScoreApplicantModal: VFC<ScoreApplicantModalProps> = ({
  applicantId,
  scorecardTemplateId,
  scorecardName,
  handleClose,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // The submitted scorecard changes the applicant's status labels; refetch
  // the detail so the label flips without a page reload.
  const handleSubmitted = () => {
    handleClose();
    void fetchApplicantData(applicantId)
      .then(response => {
        dispatch(
          updateApplicantTableStatuses(
            applicantId,
            response.data.applicant.status,
          ),
        );
      })
      .catch(() => undefined);
  };

  return (
    <Modal
      data-testid="score-applicant-modal"
      ariaLabelledBy="score-applicant-modal-header"
      open
      onClose={handleClose}
      fullScreenOnMobile
      maxWidth={860}
    >
      <ModalHeader
        onClose={handleClose}
        ariaLabelledBy="score-applicant-modal-header"
        showIcon={false}
      >
        <span className={classes.title}>{scorecardName}</span>
      </ModalHeader>
      <ScorecardForm
        variant="modal"
        applicantId={applicantId}
        scorecardTemplateId={scorecardTemplateId}
        onCancel={handleClose}
        onSubmitted={handleSubmitted}
      />
    </Modal>
  );
};
